import { Empty, Space } from 'antd'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import React from 'react'

type Props = {
  onButtonClick: () => void
}
const CategorySearchEmpty: React.FC<Props> = ({ onButtonClick }) => {
  const { tComponent } = ToolBox.useString()

  const translate = (id: string) =>
    tComponent({
      recordType: RecordType.category_search,
      componentName: 'empty',
      componentType: 'core',
      id
    })

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <Space direction="vertical">
          <p>{translate('list.title')}</p>
          <Button title={translate('list.button')} type="primary" onClick={onButtonClick} />
        </Space>
      }
    />
  )
}

export default CategorySearchEmpty
